import { FC, cloneElement } from "react";

import { Radio as RadioBase, FormControl, Box } from "@chakra-ui/react";

import { FormFieldLabel, FormMessage, FormHint } from "@components/common";
import withFormikField from "@lib/withFormikField";

import { TRadioProps } from "./types";

const Radio: FC<TRadioProps> = ({
  children,
  hint,
  size = "md",
  name,
  label,
  message,
  isDisabled,
  isInvalid,
  isRequired,
  isChecked,
  isInGroup,
  spacing = "0.625rem",
  variant = "dark",
  value,
  ...props
}) => {
  // When radio is in group, there is no need for FormControl wrapping each Radio element
  // FormControl adds aria role="group" which conflicts with role="radiogroup" which is set on RadioGroup

  const WrapperComponent = isInGroup ? <Box /> : <FormControl isDisabled={isDisabled} isInvalid={isInvalid} />;

  return cloneElement(
    WrapperComponent,
    {},
    <>
      <FormFieldLabel label={label} cursor="pointer" />
      <RadioBase
        name={name}
        value={value}
        spacing={spacing}
        size={size}
        variant={variant}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        isRequired={isRequired}
        isChecked={isChecked}
        cursor="pointer"
        {...props}
      >
        {children}
      </RadioBase>
      <FormHint hint={hint} />
      {isInvalid && <FormMessage message={message} isInvalid />}
    </>
  );
};

export default withFormikField<TRadioProps>(Radio);
